import useResellerAuth from '@/routes/hooks/useResellerAuth';
import { Loading } from '@/components/Loading';
import { Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { getResellerData } from '@/store/reseller/selector';
import { Page404 } from '@/pages/Page404';

export const ConditionalResellerRoutes = () => {
	const { isAuthenticated, isLoading } = useResellerAuth();
	const location = useLocation();
	const reseller = useAppSelector(getResellerData);

	if (isLoading) {
		return <Loading />;
	}

	// First check authentication
	if (!isAuthenticated) {
		return <Page404 />; // or redirect to login page
	}

	// Then check specific route conditions
	if (location.pathname.includes('/outbound')) {
		const outboundAllowed =
			(reseller.outboundSubscriptionId &&
				reseller.outboundSubscriptionStatus &&
				reseller.outboundSubscriptionStatus !== 'canceled') ||
			reseller.allowOutboundAccess === true;

		if (!outboundAllowed) {
			return <Page404 />;
		}
	}

	// If all checks pass, render the route
	return <Outlet />;
};

export default ConditionalResellerRoutes;
